import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { Row, Col, message, Tooltip, Modal, Spin, Layout, Input, Card, Button, Tag, Form } from "antd";
import {
  LoadingOutlined,
  ArrowLeftOutlined,
  MoreOutlined,
  CustomerServiceOutlined,
  SearchOutlined,
  CloseOutlined,
  EditOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import findIndex from "lodash/findIndex";
import { useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import All from "../../../assets/images/all.svg";
import ParkedOrder from "../../../assets/images/parkedOrder.svg";
import InProgress from "../../../assets/images/inProgress.svg";
import Pending from "../../../assets/images/pending.svg";
import Prepared from "../../../assets/images/prepared.svg";
import Completed from "../../../assets/images/completed.svg";
import BackIcon from "../../../assets/images/backIcon.svg";
import Logo from "../../../assets/images/logo-without-bg.png";
import AddUser from "../../../assets/images/userAdd.svg";
import CustomerSearch from "../../../assets/images/search.png";
import CustomerIcon from "../../../assets/images/userId.svg";
import View from "../../../assets/images/view.svg";
import Logout from "../../../assets/images/logout.png";
import SyncIcon from "../Retail/SvgComponent/SyncIcon";
import TableDineIN from "./SvgComponents/TableDineIn";
import TakeAway from "./SvgComponents/TakeAway";
import TableMenu from "./SvgComponents/TableMenu";
import TableCustomer from "./SvgComponents/TableCustomer";
import CashManagementIcon from "../Retail/SvgComponent/CashManagementIcon";
import unlinkTill from "../../../assets/images/unlink-icon.svg";
import openDrawerIcon from "../../../assets/images/openDrawer.svg";
import printerIcon from "../../../assets/images/printerIcon.svg";
import data from "../../../constants/retailPos.json";
import db from "../../../database";
import { clock } from "../../../utils/clock";
import RestaurantModals from "./RestaurantModals";
import SyncLoadingScreen from "./components/SyncLoadingScreen";
import dayjs from "dayjs";
import { kotPrinter } from "../../../lib/printer/kotPrinter";
import CWKOTPrinter from "../../../lib/printer/CWKotPrinter";
import { SyncData } from "./Tables-Management/SyncData";
import { getOAuthHeaders } from "../../../constants/oAuthValidation";
import MenuLayout from "./MenuLayout";
import CashManagement from "./cashManagement";
import OrderListComponent from "./OrderListComponent";
import useSyncProgressStore from "../../../stores/useSyncProgressStore";
import { processSync } from "../../Sync/syncData";
import TableManagement from "./Tables-Management/tables";
import TableOrder from "./SvgComponents/TableOrder";
import CustomersComponent from "./CustomersComponent";
import HomeDeliveryComponent from "./HomeDeliveryComponent";
import { useTranslation } from "react-i18next";
import RetailModals from "../Retail/RetailModals";
import { getMultilingualText } from "../../../utils/getMultilingualText";
import { useEventBus } from "../../../lib/components/EventBusProvider";
import { timeStamp } from "../../../utils/clock";
import { getNewOmsOrder, updateOMSOrderStatus, upsertWaitlist, getWaitlist, getTableReservation } from "../../../services";
import messages from "../../../errors/messages.en-IN.json";
import salesReportIcon from "../../../assets/images/salesReportIcon.svg";
import { getWorkflowData } from "../../../utils/getWorkflowData";
import TableFeatures from "./Tables-Management/TableFeatures";
import { getCustomer, createCustomer } from "../Core/customer";
import { showKDSNotification } from "./showKDSNotification";
import { numberToWords } from "../../../utils/numberToWords";
import Scrollbars from "react-custom-scrollbars";
import FBLeftSidebar from "./components/FBLeftSidebar";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";
import useCartStore from "../../../stores/useCartStore";
import useAuthStore from "../../../stores/useAuthStore";
import useRestaurantStore from "../../../stores/useRestaurantStore";
import useSessionStore from "../../../stores/useSessionStore";
import { generateDocumentNo } from "../../../utils/documentSequenceUtils";

// Extracted hooks
import useOrderHandlers from "./hooks/useOrderHandlers";
import useVoidHandler from "./hooks/useVoidHandler";
import useOrderStatusHandlers from "./hooks/useOrderStatusHandlers";
import useWaitlistReservation from "./hooks/useWaitlistReservation";
import useWebSocketHandler from "./hooks/useWebSocketHandler";
import salesReportCWHCPrinter from "../../../lib/printer/saleReportCWHCPrinter";
import { getPricingRules } from "../../../utils/pricingRulesCache";

const FBLayout = (props) => {
  const {
    //salesReportCWHCPrinter,
    salesReportPrinter,
    filteredPaymentMethods,
    getFilteredPaymentMethods,
    handleSelectedSaleTypeForProducts,
    selectedSaleType,
    setSelectedSaleType,
    saleTypeProducts,
    setSaleTypeProducts,
    cart,
    setCart,
    decreaseProductQty,
    deleteCart,
    setGiftCardData,
    deleteProduct,
    increaseProductQty,
    openDisplayParkedBillModal,
    openPaymentModal,
    orderType,
    selectProductCategory,
    selectProductInCart,
    selectedProductInCart,
    setSelectedProductInCart,
    setDisplayCustomerSearch,
    tillData,
    currencyType,
    setManualDiscountInput,
    manualDiscountModalVisible,
    setManualDiscountModalVisible,
    setDenaminationsKeyboard,
    denaminationsKeyboard,
    setAddCashFlag,
    requestPayment,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    amount,
    setAmount,
    setNumb,
    processOrder,
    handleAmount,
    handleCashPayment,
    setCashAddInFlag,
    pickProduct,
    isCardPaymentFlag,
    setIsCardPaymentFlag,
    documentSequence,
    setDocumnetSequence,
    productsData,
    setProductsData,
    allProductCategories,
    orderTypeSelection,
    setOrderTypeSelection,
    addDefinedProductWithAddons,
    setManualDiscountTypes,
    manualDiscountForm,
    setSelectedManualDiscountTypeValue,
    isSaleTypeFlag,
    setIsSaleTypeFlag,
    showProducts,
    setShowProducts,
    keyValue,
    setKeyValue,
    tableCards,
    setTableCards,
    clearCart,
    splitCarts,
    setSplitCarts,
    dynamicForm,
    setDynamicForm,
    setSaleType,
    saleType,
    selectedItemsModalOpen,
    setSelectedItemsModalOpen,
    notesValue,
    setNotesValue,
    selectedProductForNotes,
    setIsInputFocused,
    keyboardRef,
    setSelectedProductForNotes,
    searchOrderHistory,
    orderHistoryDetails,
    setOrderHistoryDetails,
    getSalesHistoryData,
    isPrintModeXML,
    upsertPOSLog,
    setFiltersFlag,
    dateRange,
    setDateRange,
    getDisplayDate,
    content,
    searchHistoryInput,
    setSearchhistoryInput,
    ordersCopy,
    dateRef,
    filtersFlag,
    callCenterVisible,
    setCallCenterVisible,
    removeCutomer,
    showAddNewCustomerFields,
    setProductSearchInput,
    customerId,
    setCloseCustomerFlag,
    setCustomerSearchResults,
    setCustomerSearchInput,
    handleCustomerSearch,
    showEditOldCustomerFields,
    setEditFlag,
    setKeyboardInputFields,
    keyboardInputFields,
    displayCustomerSearch,
    isCallCenterFlow,
    setIsCallCenterFlow,
    showCallCenterPage,
    setShowCallCenterPage,
    holdQueue,
    setHoldQueue,
    handleCopyKOT,
    onCancel,
    guestForm,
    kioskLogin,
    setKioskUI,
    addNewCustomer,
    copyKOTVisible,
    setCopyKOTVisible,
    groupedFiredItems,
    setGroupedFiredItems,
    openCopyKOTModal,
    selectedCopyItems,
    setSelectedCopyItems,
    filterdParkedList,
    setFilterdParkedList,
    retrieveParkedData,
    discardMessage,
    parkedList,
    setParkedList,
    displayAddOnSelection,
    setDisplayAddOnSelection,
    addonSourceItem,
    setAddonSourceItem,
    showAddonsCustomizePopup,
    setShowAddonsCustomizePopUp,
    addonRepeatDisabled,
    setAddonRepeatDisabled,
    selectedReturnOrder,
    setSelectedReturnOrder,
    setCheckedKeys,
    checkedKeys,
    addSelectedReturnProductsToCart,
    getProductData,
    handleSaveReturnCartRecord,
    dataSource,
    setDataSource,
    showReturnPurchase,
    setShowReturnPurchase,
    selectPurchaseBillForReturn,
    retrunSearchType,
    setReturnSearchType,
    searchReturnHistory,
    selectedProduct,
    setSelectedProduct,
    setAddOnsList,
    addOnsList,
    handleAddOnModal,
    productSearchInput,
    loading,
    setLoading,
    syncOrders,
  } = props;
  const history = useHistory();
  const { t } = useTranslation();
  const username = useAuthStore.getState().username;
  const salesReps = tillData?.tillAccess?.csBunit?.salesRep || [];
  const matchedRep = salesReps.find((rep) => rep.name === username);
  const domainURL = process.env.REACT_APP_domain;
  const multilingual = process.env.REACT_APP_MULTILINGUAL === "true" && localStorage.getItem("selectedLanguage") !== "English";
  const { percent, promotionPercentage, productPercentage, productCategoryPercentage } = useSyncProgressStore();
  const tillaccess = JSON.parse(tillData?.tillAccess?.userAccessController || "{}");
  const accessController = JSON.parse(tillData?.tillAccess?.cwrTill?.accessController || "{}");
  // SAVING BILL BLOCK START //
  const storedLocatedList = useRestaurantStore.getState().locatedList;
  const initialLocatedList = storedLocatedList ? storedLocatedList : [];
  const [locatedList, setLocatedList] = useState(initialLocatedList);
  const [selectedTable, setSelectedTable] = useState(useRestaurantStore.getState().tableName !== null ? useRestaurantStore.getState().tableName : history?.location?.state || "");
  const [orderedData, setOederedData] = useState([]);
  const [tempProducts, setTempProducts] = useState([]);
  const [orderCanceled, setOrderCanceled] = useState(false);
  const [productsList, setProductsList] = useState([]);
  const [paymentVisible, setPaymentVisible] = useState(false);
  const [showOrderCompleteFlag, setShowOrderCompleteFlag] = useState(false);
  const [syncLoad, setSyncLoad] = useState(false);
  const [reloadTablesFlag, setReloadTablesFlag] = useState(0);
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [showMoreMenu, setShowMoreMenu] = useState(false);
  const [clock1, setClock1] = useState(clock());
  const [occupiedDataTablesData, setOcupiedTablesData] = useState([]);
  const [reservedTablesData, setReservedTablesData] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [tableList, setTableList] = useState([]);
  const colorVariable = process.env.REACT_APP_POSBACKGROUND_COLOR;
  const userPreferences = JSON.parse(localStorage.getItem("userPreferences")) || { dateFormat: "DD-MM-YYYY", dateTimeFormat: "DD-MM-YYYY HH:mm:ss" };
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  const { dispatchEvent } = useEventBus();
  const userData = useAuthStore.getState().userData;
  const tillValue = useAuthStore.getState().tillValue;
  const defaultCustomer = tillData.tillAccess.csBunit.b2cCustomer;
  const [showSplitBill, setShowSplitBill] = useState(false);
  const [splitBillScreen, setSplitBillScreen] = useState(false);
  const [numSplits, setNumSplits] = useState(2);
  const [showAllItems, setShowAllItems] = useState(true);
  const [isSplitBill, setIsSplitBill] = useState(false);
  const [currentSplitIndex, setCurrentSplitIndex] = useState(0);
  const [recordState, setRecardState] = useState("");
  const [removeSplit, setRemoveSplit] = useState([]);
  const CWHardwareController = tillData?.tillAccess?.cwrTill?.printTemplate?.cwController === "Y" ? true : false;
  const [mainTableData, setMainTableData] = useState([]);
  const tillDocumentSequence = useSessionStore.getState().documentSequence;
  const [selectedProducts, setSelectedproducts] = useState([]);
  const [showSendToKitchen, setShowSendToKitchen] = useState(false);
  const [guestsModalFlag, setGuestsModalFlag] = useState(false);
  const [noOfPersons, setNumberOfPersons] = useState("");
  const [priorityBtn, setPriorityBtn] = useState(false);
  const [orderFlags, setOrderFlags] = useState([]);
  // const [loading, setLoading] = useState(false);
  const [restaurantButtonLoading, setRestaurantButtonLoading] = useState(false);
  const [fireItems, setFireItems] = useState([]);
  const [fireMode, setFireMode] = useState("single");
  const [pendingFireItems, setPendingFireItems] = useState([]);
  const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const [saleTypesInfo, setSaleTypesInfo] = useState([]);
  const [selectedSaleTypeIndex, setSelectedSaleTypeIndex] = useState(null);
  const [isDefaultSaleTypeSet, setIsDefaultSaleTypeSet] = useState(false);
  const [form, setForm] = useState({
    guestName: "",
    phone: "",
    resDate: null,
    resTime: null,
    guestCount: null,
    specialReq: "",
    tableNum: "",
    section: "",
  });
  const [fbTableId, fbSectionId] = form.tableNum ? form.tableNum.split("-") : [null, null];
  const [reserveModalOpen, setReserveModalOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isNewGuestCustomer, setIsNewGuestCustomer] = useState(false);
  const [reservationsBlank, setReservationsBlank] = useState(false);
  const [mergeDrawerOpen, setMergeDrawerOpen] = useState(false);
  const [selectData, setSelectData] = useState([]);
  const [displayReserveTablesPopup, setDisplayReserveTablesPopup] = useState(false);
  const [radioValue, setRadioValue] = useState({ value: "all", name: "All" });
  const [inputFields, setInputFields] = useState({});
  const [guestMobile, setGuestMobile] = useState("");
  const [reservePhone, setReservePhone] = useState("");
  const [seatGuestDrawerOpen, setSeatGuestDrawerOpen] = useState(false);
  const [transferBill, setTransferBill] = useState(false);
  const [cancelKotItems, setCancelKotItems] = useState(false);
  const [waitlistDrawerOpen, setWaitlistDrawerOpen] = useState(false);
  const [billConfirmationModalOpen, setBillConfirmationModalOpen] = useState(false);
  const [notesModalOpen, setNotesModalOpen] = useState(false);
  const [layout, setLayout] = useState("default");
  const [inputs, setInputs] = useState({});
  const [inputName, setInputName] = useState("");
  const [categorieFlag, setCategorieFlag] = useState(false);
  const keyboard = useRef(null);
  const prevCustomerIdRef = useRef(null);
  const inputRef = useRef(null);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [reserveTableForm] = Form.useForm();
  const numbers = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10+"];

  const getDefaultSaleType = async () => {
    const saleData = await db.posSaletypes.toArray();
    const defaultSale = saleData.find((sale) => sale?.cwrSaletype?.isdefault === "Y");
    if (defaultSale) return defaultSale;
    const dineInSale = saleData.find((sale) => sale?.cwrSaletype?.fulfilmentType === "DI");
    if (dineInSale) return dineInSale;
    const takeAwaySale = saleData.find((sale) => sale?.cwrSaletype?.fulfilmentType === "TA");
    if (takeAwaySale) return takeAwaySale;
    return saleData[0];
  };

  useEffect(() => {
    const initializeCart = async () => {
      const cartDetails = useCartStore.getState().cart;
      if (cartDetails?.preOrder === "Y") {
        useRestaurantStore.getState().setDineIn("N");
        setKeyValue("2");
        const saleData = await db.posSaletypes.toArray();
        const takeAwaySaleType = saleData.find((st) => st?.cwrSaletype?.fulfilmentType === "TA");
        if (takeAwaySaleType) {
          setSelectedSaleTypeIndex(1);
          await handleSelectedSaleTypeForProducts(takeAwaySaleType)();
          setCart(cartDetails);
          setSaleType("TA");
        }
      } else {
        const defaultSaleType = await getDefaultSaleType();
        const cartData = {
          items: [],
          couponInput: [],
          total: 0,
          tax: 0,
          discount: 0,
          paid: 0,
          change: 0,
          totalQty: 0,
          roundOff: 0,
          payments: [],
          redemptionPoints: 0,
          accumulationPoints: 0,
          creditAmount: 0,
          sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
          referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
          giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
          customer: defaultSaleType?.customer?.b2cCustomerId ? defaultSaleType.customer : tillData.tillAccess.csBunit.b2cCustomer,
          couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
          salesRepId: null,
          cardPaymentData: {},
          documentno: `${tillData.tillAccess.cwrTill.prefix}${tillDocumentSequence + 1}`,
          userName: userData.user,
          tillName: tillValue?.name,
          subTotal: 0,
          itemsSummery: {},
          amountInWords: "",
          groupedItemsByTaxRate: {},
          serviceCharge: 0,
          tip: 0,
          deiveryCharge: 0,
          packingCharge: 0,
        };
        setCart(cartData);
      }
    };
    initializeCart();
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.shiftKey && event.key === "+") {
        setDynamicForm(false);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [dynamicForm]);

  useEffect(() => {
    const handleOrderComplete = () => setShowOrderCompleteFlag(true);
    window.addEventListener("restaurant:orderComplete", handleOrderComplete);
    return () => window.removeEventListener("restaurant:orderComplete", handleOrderComplete);
  }, []);

  useEffect(() => {
    const pr = getPricingRules();
    const manualPricingRules = pr.filter((rule) => rule.manualDiscount === "Y");
    setManualDiscountTypes([...manualPricingRules]);
  }, []);

  useEffect(() => {
    const getSaleTypeData = async () => {
      const saleData = await db.posSaletypes.toArray();
      const filteredSaleData = saleData?.filter(
        (sale) => sale?.cwrSaletype?.fulfilmentType === "TA" || sale?.cwrSaletype?.fulfilmentType === "DI" || sale?.cwrSaletype?.fulfilmentType === "DE"
      );
      setSaleTypesInfo(filteredSaleData);
    };
    getSaleTypeData();
  }, []);

  useEffect(() => {
    if (tableCards?.length > 0) {
      setOcupiedTablesData(tableCards.filter((t) => t.statusType === "OCU" || t.statusType === "ONG"));
      setReservedTablesData(tableCards.filter((t) => t.statusType === "RES"));
    }
  }, [tableCards]);

  const fulfilmentPriority = ["DI", "TA", "DE"];
  const fulfilmentToKeyMap = { DI: "0", DE: "1", TA: "2" };
  const fulfilmentIconMap = { DI: TableDineIN, TA: TableMenu, DE: TakeAway };

  const sortedSaleTypes = useMemo(() => {
    return [...(saleTypesInfo || [])].sort((a, b) => {
      return fulfilmentPriority.indexOf(a?.cwrSaletype?.fulfilmentType) - fulfilmentPriority.indexOf(b?.cwrSaletype?.fulfilmentType);
    });
  }, [saleTypesInfo]);

  const defaultFulfilmentType = fulfilmentPriority.find((type) => sortedSaleTypes.some((st) => st?.cwrSaletype?.fulfilmentType === type));

  useEffect(() => {
    const isPreOrderPage = window.location.pathname.includes("/preorder");
    const isRetrieve = localStorage.getItem("isRetrieve") === "Y";
    if (!sortedSaleTypes.length) return;
    if (isDefaultSaleTypeSet) return;
    if (selectedSaleTypeIndex !== null) return;
    if (isPreOrderPage) return;
    if (isRetrieve) {
      localStorage.removeItem("isRetrieve"); // cleanup
      return;
    }
    const defaultType = fulfilmentPriority.find((type) => sortedSaleTypes.some((st) => st?.cwrSaletype?.fulfilmentType === type));
    const selectedSaleTypeObj = sortedSaleTypes.find((st) => st?.cwrSaletype?.fulfilmentType === defaultType);
    if (!selectedSaleTypeObj) return;
    const fulfilmentType = selectedSaleTypeObj?.cwrSaletype?.fulfilmentType;
    const index = sortedSaleTypes.findIndex((st) => st?.cwrSaletype?.fulfilmentType === fulfilmentType);
    setSelectedSaleTypeIndex(index);
    setSaleType(fulfilmentType);
    useRestaurantStore.getState().setDineIn(fulfilmentType === "DI" ? "Y" : "N");
    handleKeyvalue(fulfilmentToKeyMap[fulfilmentType], fulfilmentType);
    handleSelectedSaleTypeForProducts(selectedSaleTypeObj)();
    setIsDefaultSaleTypeSet(true);
  }, [sortedSaleTypes, isDefaultSaleTypeSet]);

  const getSaleTypeArray = async (type) => {
    try {
      const saleTypes = await db.posSaletypes.toArray();
      const selectedSaleTypeArray = saleTypes.filter((saleType) => saleType.cwrSaletype.fulfilmentType === type);
      return selectedSaleTypeArray.length > 0 ? selectedSaleTypeArray[0] : null;
    } catch (error) {
      console.error("Error fetching sale types:", error);
      return [];
    }
  };

  const formattedDateTime = `${currentDateTime.toLocaleTimeString()} | ${currentDateTime.toLocaleDateString("en-US", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  })}`;

  let cleanToken;
  const authHeaders = getOAuthHeaders();
  if (authHeaders) {
    cleanToken = authHeaders.access_token;
  }

  const handleKeyvalue = (value, fulfilmentType) => {
    setKeyValue(value);
    useRestaurantStore.getState().setDineIn(fulfilmentType === "DI" ? "Y" : "N");
    if (value === "2") {
      useRestaurantStore.getState().setHomeDelivery("N");
    }
    if (value !== "2") {
      useRestaurantStore.getState().setHomeDelivery("Y");
    }
  };

  useEffect(() => {
    db.products
      .filter((product) => product.isactive == true)
      .filter((product) => product.productSegment !== "BG")
      .toArray()
      .then((productsFetched) => {
        setProductsList([...productsFetched.slice(0, 50)]);
      });
  }, []);

  const clearCartData = {
    items: [],
    couponInput: [],
    advancePayment: 0,
    total: 0,
    tax: 0,
    discount: 0,
    paid: 0,
    change: 0,
    totalQty: 0,
    roundOff: 0,
    payments: [],
    redemptionPoints: 0,
    accumulationPoints: 0,
    creditAmount: 0,
    docType: "Invoice",
    sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
    referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
    giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
    couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
    customer: defaultCustomer,
    salesRepId: null,
    cardPaymentData: {},
    documentno: `${tillData.tillAccess.cwrTill.prefix}${tillDocumentSequence + 1}`,
    userName: userData.user,
    tillName: tillValue?.name,
    subTotal: 0,
    itemsSummery: {},
    amountInWords: "",
    groupedItemsByTaxRate: {},
  };

  const onChangeInput = (event) => {
    const inputVal = event.target.value;
    setKeyboardInputFields({
      ...keyboardInputFields,
      [inputName]: inputVal,
    });
    keyboard?.current?.setInput(inputVal);
  };

  // ── Waitlist & Reservation ────────────────────────────────────────────────
  const {
    waitlistTab,
    setWaitlistTab,
    waitlistForm,
    setWaitlistForm,
    waitlistErrors,
    setWaitlistErrors,
    waitlistList,
    setWaitlistList,
    reservationList,
    setReservationList,
    errors,
    setErrors,
    saveToWaitlist,
    waitlistSubmitting,
    loadWaitlistForUI,
    validateWaitlistForm,
    validateForm,
    loadReservations,
  } = useWaitlistReservation({
    tillData,
    cart,
    setCart,
    addNewCustomer,
    noOfPersons,
    reservePhone,
    tableList,
    reserveTableForm,
    setWaitlistDrawerOpen,
  });

  // ── Order Status Handlers ─────────────────────────────────────────────────
  const {
    orderStatus,
    displayOrderItemsModal,
    setDisplayOrderItemsModal,
    selectedOrderStatus,
    setSelectedOrderStatus,
    orderDetails,
    setOrderDetails,
    barcodeOrderList,
    setBarcodeOrderList,
    barcodeOrderStatusModal,
    setBarcodeOrderStatusModal,
    handleOrderStatus,
    handleOrderStatusSelection,
    handleStatusButton,
    handleInProgress,
    handleAccept,
    handleBarcodeOrderPrint: handleBarcodeOrderPrintRaw,
  } = useOrderStatusHandlers({ tillData });

  // Wrap to inject tillData.tillAccess.csBunit.name
  const handleBarcodeOrderPrint = (printedData) => handleBarcodeOrderPrintRaw(printedData, tillData.tillAccess.csBunit.name);

  // ── Core Order Handlers ───────────────────────────────────────────────────
  const { handleNewOrder, handleExistingOrder, cleanupCompletedOrders, handleOrder, handleTable, handleDisplayOk, handleCancelOrder } = useOrderHandlers({
    cart,
    setCart,
    selectedTable,
    setSelectedTable,
    setTableCards,
    setOcupiedTablesData,
    setReservedTablesData,
    setTableList,
    setOederedData,
    setPendingFireItems,
    setSelectedItemsModalOpen,
    setShowProducts,
    setKeyValue,
    clearCartData,
    documentSequence,
    setDocumnetSequence,
    pendingFireItems,
    fireMode,
    posConfig,
    tillData,
    userPreferences,
    precision,
    CWHardwareController,
    history,
    guestForm,
    setGuestMobile,
    setInputFields,
    setPriorityBtn,
    setRecardState,
    setShowSendToKitchen,
    inputRef,
    setGuestsModalFlag,
    setSplitBillScreen,
    setNumSplits,
    setIsSplitBill,
    setCurrentSplitIndex,
    setSplitCarts,
  });

  // ── clearCart1 helper needed by handleVoid ────────────────────────────────
  const clearCart1 = async (type) => {
    const tillSession = useSessionStore.getState().tillSession;
    const tillSessionId = tillSession.tillSessionId;
    const newDocumentSequence = cart.parked === "Y" || cart.statusType === "OCU" ? documentSequence : documentSequence + 1;
    let cartToDb = cart;
    cartToDb.orderTime = timeStamp();
    cartToDb.createdBy = tillData.tillAccess.csUserId;
    cartToDb.orderType = orderType?.cwrSaletype?.cwrSaletypeId;
    cartToDb.orderDate = dayjs(new Date()).format("YYYY-MM-DD");
    cartToDb.tillSessionId = tillSessionId;
    cartToDb.key = uuidv4().replace(/-/g, "").toUpperCase();
    cartToDb.isSynced = 0;
    cartToDb.syncAttempts = 0;
    cartToDb.customerSearchKey = cart.customer.code;
    cartToDb.tax = 0;
    cartToDb.total = 0;
    cartToDb.docType = "Invoice";
    cartToDb.totalQty = 0;
    cartToDb.couponInput = [];
    cartToDb.discount = 0;
    cartToDb.isReturn = false;
    cartToDb.items.forEach((item) => {
      item.salePrice = 0;
      item.sunitprice = 0;
      item.netStd = 0;
      item.nettotal = 0;
      item.unitTax = 0;
      item.taxAmount = 0;
      item.weight = 0;
      item.unitPrice = 0;
      item.isReturn = false;
      item.netList = 0;
      item.discount = 0;
      item.linetax = 0;
      item.linenet = 0;
      item.linegross = 0;
      item.linestd = 0;
      item.netunit = 0;
      item.listPrice = 0;
      item.grossunit = 0;
      item.grossstd = 0;
      item.grosslist = 0;
    });
    setGiftCardData([]);
    if (type === "Layaway") {
      const cancelledSeqLW = useSessionStore.getState().cancelledOrderSequence;
      if (cancelledSeqLW) {
        cartToDb.documentno = generateDocumentNo(cancelledSeqLW);
        useSessionStore.getState().incrementCancelledOrderSequence();
        deleteCart(true, "ownSequence");
      } else {
        deleteCart(true, cart.parked === "Y" ? "parked" : cartToDb.type);
      }
    } else {
      const cancelledSeq = useSessionStore.getState().cancelledOrderSequence;
      if (cancelledSeq) {
        cartToDb.documentno = generateDocumentNo(cancelledSeq);
        useSessionStore.getState().incrementCancelledOrderSequence();
        deleteCart(true, "ownSequence");
      } else {
        const nextCartNo = `${tillData.tillAccess.cwrTill.prefix}${newDocumentSequence + 1}`;
        useSessionStore.getState().setDocumentSequence(newDocumentSequence);
        setDocumnetSequence(newDocumentSequence);
        deleteCart(true, cart.parked === "Y" ? "parked" : cartToDb.type, false, nextCartNo);
      }
    }
    // Persist and sync the cancelled-order snapshot regardless of type — this ran
    // unconditionally before the cancelled-sequence feature was added; a later
    // refactor accidentally nested it inside the non-Layaway branch only, which
    // silently dropped the cancel record (and its server sync) for Layaway/Advance
    // cancellations.
    await db.orders.put(cartToDb);
    if (posConfig?.disableOfflineBilling === "Y") {
      syncOrders("auto");
    }
  };

  // ── Void Handler ──────────────────────────────────────────────────────────
  const { handleVoid, cancelling } = useVoidHandler({
    cart,
    setCart,
    history,
    setKeyValue,
    setShowProducts,
    tillData,
    precision,
    setCategorieFlag,
    clearCart1,
    setTableCards,
    setOcupiedTablesData,
    setReservedTablesData,
    setTableList,
    setLoading,
  });

  // ── WebSocket Handler ─────────────────────────────────────────────────────
  useWebSocketHandler({
    tillData,
    setTableCards,
    setOcupiedTablesData,
    setReservedTablesData,
    setTableList,
    setShowProducts,
    setCart,
    precision,
  });

  // ── Table data fetch on selectedTable/orderCanceled change ────────────────
  useEffect(() => {
    const fetchTableData = async () => {
      try {
        if (!selectedTable) return;
        let newCart = cart;
        const tableData = await db.tableData.where("cwrFbTableId").equals(selectedTable?.cwrFbTableId).toArray();
        if (tableData.length > 0) {
          if ((tableData[0].ordered === "N" || !tableData[0].ordered) && tableData[0].statusType !== "ONG" && tableData[0].statusType !== "STD") {
            await handleNewOrder(tableData[0], newCart, userPreferences);
          } else {
            await handleExistingOrder(selectedTable);
          }
          await cleanupCompletedOrders();
        }
      } catch (error) {
        console.error("Error in useOrderManagement:", error);
      }
    };
    fetchTableData();
  }, [orderCanceled, selectedTable]);

  // ── getCustomerData ───────────────────────────────────────────────────────
  const getCustomerData = async (values) => {
    const mobileNumber = guestMobile;

    if (isNewGuestCustomer) {
      const newCust = {
        name: values.guestName || "",
        mobile: mobileNumber,
        email: "",
        pincode: "",
        city: "",
        street: "",
        lastName: "",
      };
      await addNewCustomer(newCust);
    }

    setGuestsModalFlag(false);
    setNumberOfPersons("");
    useRestaurantStore.getState().setDineIn("Y");

    let tabledata = [];
    let updatedTable = null;
    await db.tableData.toArray().then((fetched) => {
      fetched.map((item) => {
        if (item.cwrFbTableId === recordState.cwrFbTableId) {
          item.noOfPersons = values?.noOfGuests ?? 0;
          item.waiter = values?.waiterId ?? "";
          item.salesRepId = values?.waiterId ?? "";
          item.referredBy = values?.referredBy ?? "";
          item.guestName = values?.guestName ?? "";
          item.tableSync = "N";
          item.statusType = "STD";
          item.fbtableStatusId = item.fbtableStatusId ?? uuidv4().replace(/-/g, "").toUpperCase();
          item.guestType = priorityBtn ? "single" : "family";
          item.salesRepId = tillData.tillAccess.salesRepId;
          item.uniqueId = uuidv4().replace(/-/g, "").toUpperCase();
          item.color = "#978ea1";
          item.ordered = "N";
          item.items = [];
          item.startedAt = dayjs().format("YYYY-MM-DD HH:mm");
          updatedTable = { ...item };
        }
        tabledata.push(item);
      });
    });

    await db.tableData.clear();
    await db.tableData.bulkPut(tabledata);

    if (updatedTable) {
      await SyncData(updatedTable, "upsertTableStatus");
    }

    useRestaurantStore.getState().setLocatedList(tabledata);
    useRestaurantStore.getState().setTableName(recordState);

    setSelectedTable(recordState);
    setTableCards(tabledata);
    setMainTableData(tabledata);
    setOcupiedTablesData(tabledata.filter((table) => table.statusType === "OCU" || table.statusType === "ONG"));
    setShowProducts(true);

    if (posConfig?.enableGuestRegistration !== "Y") {
      handleDisplayOk(recordState);
    }
  };

  // ── Reserve table helpers ─────────────────────────────────────────────────
  const handleReserveTable = () => {
    guestForm.resetFields();
    setGuestMobile("");
    setInputFields({});
    setNumberOfPersons("");
    let newTime = dayjs(new Date());
    reserveTableForm.setFieldsValue({ section: radioValue.value, time: newTime });
    setDisplayReserveTablesPopup(true);
  };

  const handleNumberClick = (number) => {
    setNumberOfPersons(number);
    reserveTableForm.setFieldsValue({ noOfPersons: number });
  };

  const handleClick = () => {
    setNumberOfPersons("");
    setDisplayReserveTablesPopup(false);
    setInputFields("");
    reserveTableForm.resetFields();
    setGuestsModalFlag(false);
  };

  const handleOnChange = (key) => {
    let tempData = [];
    if (key === "all") {
      tempData.push(...mainTableData);
    } else {
      mainTableData.map((e) => {
        if (e.cwrFbsectionId === key) {
          tempData.push(e);
        }
      });
    }
    setTableList(tempData);
  };

  // ── Addon handlers ────────────────────────────────────────────────────────
  const handleAddOnValue = (e, fieldName) => {
    let newSelectedAddons = [...selectedAddons];
    const indexValue =
      fieldName === "addOnRadio"
        ? findIndex(newSelectedAddons, (item) => item.mAddonGroup.mAddonGroupId === e.target.value.mAddonGroup.mAddonGroupId)
        : findIndex(newSelectedAddons, (item) => item === e.target.value);
    if (indexValue !== -1) {
      if (e.target.checked) {
        newSelectedAddons[indexValue] = e.target.value;
      } else {
        newSelectedAddons.splice(indexValue, 1);
      }
    } else {
      newSelectedAddons = [...selectedAddons, e.target.value];
    }
    setSelectedAddons(newSelectedAddons);
  };

  const handleQty = (fieldName) => {
    let newSelectedProduct = { ...selectedProduct, weight: selectedProduct?.weight || 1 };
    if (fieldName === "plus") {
      newSelectedProduct.weight = Number(newSelectedProduct.weight) + 1;
    }
    if (fieldName === "minus") {
      newSelectedProduct.weight = Number(newSelectedProduct.weight) - 1;
      if (newSelectedProduct.weight <= 1) {
        newSelectedProduct.weight = 1;
      }
    }
    setSelectedProduct({ ...newSelectedProduct });
  };

  const handleAdd = async () => {
    await addDefinedProductWithAddons(
      {
        ...selectedProduct,
        sProductID: uuidv4().replace(/-/g, "").toUpperCase(),
        productAddons: selectedAddons || [],
      },
      selectedProduct.upc,
      null,
      null,
      selectedProduct.sunitprice,
      false
    );
    handleAddOnModalClose();
  };

  const handleAddOnModalClose = () => {
    setDisplayAddOnSelection(false);
    setSelectedAddons([]);
  };

  // ── Manual discount ───────────────────────────────────────────────────────
  const manualDiscountRestaurant = async (values) => {
    if (selectedProductInCart) {
      const pr = getPricingRules();
      const index = pr.findIndex((md) => md.mPricingrulesId === selectedProductInCart?.mPricingruleId && md.manualDiscount === "Y");
      if (index !== -1) {
        const pricingRule = pr[index];
        if (pricingRule.type !== "TD") {
          let discountValue =
            pricingRule.discountType === "V"
              ? selectedProductInCart.discount
              : ((selectedProductInCart.discount / (selectedProductInCart?.realPrice * selectedProductInCart?.weight)) * 100).toFixed(2);
          manualDiscountForm.setFieldsValue({ discountName: pricingRule.mPricingrulesId, discountValue: discountValue });
          setManualDiscountInput(discountValue);
          setSelectedManualDiscountTypeValue(pricingRule);
        } else {
          const matchedPricingRule = cart?.manualDiscountData?.totalLevelDiscount?.findIndex((item) => item.pricingRule === pricingRule.mPricingrulesId);
          manualDiscountForm.setFieldsValue({
            discountName: pricingRule.mPricingrulesId,
            discountValue: cart?.manualDiscountData?.totalLevelDiscount[matchedPricingRule]?.discountValue,
          });
          setManualDiscountInput(cart?.manualDiscountData?.totalLevelDiscount[matchedPricingRule]?.discountValue);
          setSelectedManualDiscountTypeValue(pricingRule);
        }
      } else {
        manualDiscountForm.resetFields();
        setManualDiscountInput("");
        setSelectedManualDiscountTypeValue("");
      }
    }
    parseInt(cart.total) > 0 && setManualDiscountModalVisible(true);
  };

  // ── Till unlink ───────────────────────────────────────────────────────────
  const tillUnlink = async () => {
    let parkedBills = useSessionStore.getState().parkedList;
    let posConfigState = usePOSConfigStore.getState().posConfig;
    const orders = await db.orders.where("isSynced").equals(0).toArray();
    if (parkedBills?.length > 0) {
      message.error(`${t("unlink_till_parked_bill_error")}`);
    } else if (cart?.items?.length > 0) {
      message.error(`${t("unlink_till_cart_error")}`);
    } else if (orders?.length > 0) {
      message.error(`${messages.errors.till_management.unlink_till_sync_po}`);
    } else {
      if (posConfigState?.shiftClose === "Y") {
        if (posConfigState?.showDenominations === "Y") {
          useSessionStore.getState().setUnlink(true);
          history.push("/close-till");
        } else if (posConfigState?.showDenominations === "N") {
          useSessionStore.getState().setUnlink(true);
          history.push("/close-till-all");
        }
      } else {
        history.push("/till");
      }
    }
  };

  const [isUnlinkTillClicked, setIsUnlinkTillClicked] = useState(false);

  const hasUnfiredItems = cart.items.some((item) => item.order !== "Y" && !item.isHold);

  const handleUnlinkTillClick = () => {
    if (cart.paid > 0) {
      message.warning(`${messages.errors.till_management.delete_payment_method}`);
      return;
    }
    if (cart.items.length > 0 && useRestaurantStore.getState().dineIn === "N") {
      message.warning(`${messages.errors.cart.cart_switch_section}`);
      return;
    }
    if (showSendToKitchen && hasUnfiredItems) {
      message.warning(`${messages.errors.cart.cart_switch_section}`);
      return;
    }
    if (splitBillScreen) {
      message.warning(messages.errors.cart.cart_switch_section);
      return;
    }
    setIsUnlinkTillClicked(true);
    tillUnlink();
  };

  useEffect(() => {
    if (keyValue === "0" && accessController?.dineIn === "N") {
      setKeyValue("2");
    }
  }, []);

  useEffect(() => {
    if (cart?.items?.length > 0) {
      const preciseTotal = parseFloat(cart?.total?.toFixed(precision));
      let updatedCart = {
        ...cart,
        total: preciseTotal,
        totalStd: cart?.items?.reduce((sum, item) => (item?.isCanceled === "Y" ? sum : sum + (item?.linestd || 0)), 0) || 0,
        amountInWords: numberToWords(preciseTotal),
      };
      setCart(updatedCart);
    }
  }, [cart?.items?.length, cart?.total]);

  const restaurantProductCategory = async (categorie) => {
    const filteredProducts = saleTypeProducts.filter((product) => product.mProductCategoryId === categorie);
    setProductsData(filteredProducts);
  };

  const antIcon = <LoadingOutlined style={{ fontSize: "24px" }} spin />;

  const tableLayoutProps = {
    cancelling,
    restaurantButtonLoading,
    setRestaurantButtonLoading,
    setSelectedSaleTypeIndex,
    cancelKotItems,
    setCancelKotItems,
    transferBill,
    setTransferBill,
    seatGuestDrawerOpen,
    setSeatGuestDrawerOpen,
    selectData,
    setSelectData,
    orderFlags,
    setOrderFlags,
    setFiltersFlag,
    guestsModalFlag,
    setGuestsModalFlag,
    noOfPersons,
    setNumberOfPersons,
    priorityBtn,
    setPriorityBtn,
    getCustomerData,
    selectedProducts,
    setSelectedproducts,
    removeSplit,
    setRemoveSplit,
    clearCart,
    isSplitBill,
    setIsSplitBill,
    currentSplitIndex,
    setCurrentSplitIndex,
    splitCarts,
    setSplitCarts,
    showAllItems,
    setShowAllItems,
    numSplits,
    setNumSplits,
    splitBillScreen,
    setSplitBillScreen,
    showSplitBill,
    setShowSplitBill,
    tableList,
    setTableList,
    saleType,
    setSaleType,
    handleAmount,
    handleCashPayment,
    isCardPaymentFlag,
    setIsCardPaymentFlag,
    requestPayment,
    amount,
    setAmount,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    posConfig,
    setSelectedProductInCart,
    selectedProductId,
    setSelectedProductId,
    manualDiscountRestaurant,
    filteredPaymentMethods,
    getFilteredPaymentMethods,
    keyValue,
    setKeyValue,
    cart,
    setCart,
    showProducts,
    setShowProducts,
    selectedSaleType,
    setSelectedSaleType,
    selectProductCategory,
    restaurantProductCategory,
    productsData,
    pickProduct,
    handleAddOnModal,
    decreaseProductQty,
    deleteProduct,
    increaseProductQty,
    handleOrder,
    handleVoid,
    cancelling,
    setAddCashFlag,
    setCashAddInFlag,
    selectedTable,
    setSelectedTable,
    paymentVisible,
    setPaymentVisible,
    showOrderCompleteFlag,
    setShowOrderCompleteFlag,
    addDefinedProductWithAddons,
    userPreferences,
    occupiedDataTablesData,
    setOcupiedTablesData,
    reservedTablesData,
    setReservedTablesData,
    saleTypeProducts,
    setSaleTypeProducts,
    setNumb,
    processOrder,
    setDenaminationsKeyboard,
    denaminationsKeyboard,
    userData,
    tillValue,
    defaultCustomer,
    clearCartData,
    recordState,
    setRecardState,
    mainTableData,
    showSendToKitchen,
    setShowSendToKitchen,
    getSalesHistoryData,
    isPrintModeXML,
    upsertPOSLog,
    dateRange,
    setDateRange,
    getDisplayDate,
    content,
    searchHistoryInput,
    setSearchhistoryInput,
    ordersCopy,
    dateRef,
    filtersFlag,
    ...props,
  };

  if (props.layoutShortcutHandlersRef) {
    const switchFulfilment = (type) => {
      const obj = sortedSaleTypes.find((st) => st?.cwrSaletype?.fulfilmentType === type);
      if (!obj) return;
      const idx = sortedSaleTypes.indexOf(obj);
      setSelectedSaleTypeIndex(idx);
      setSaleType(type);
      useRestaurantStore.getState().setDineIn(type === "DI" ? "Y" : "N");
      handleKeyvalue(fulfilmentToKeyMap[type], type);
      handleSelectedSaleTypeForProducts(obj)();
      setShowProducts(type === "TA");
    };
    props.layoutShortcutHandlersRef.current = {
      fulfillmentDI: () => switchFulfilment("DI"),
      fulfillmentDE: () => switchFulfilment("DE"),
      fulfillmentTA: () => switchFulfilment("TA"),
      guestCount: () => {
        if (selectedTable) setSeatGuestDrawerOpen(true);
      },
    };
  }

  const calls = [
    { name: "Rahul Verma", phone: "+91 98765 43210", city: "Bengaluru", loyalty: 420, holdTime: "4:05", priority: "HIGH" },
    { name: "Priya Sharma", phone: "+91 87654 32109", city: "Bengaluru", loyalty: 280, holdTime: "3:00", priority: "HIGH" },
    { name: "Amit Patel", phone: "+91 76543 21098", city: "Indiranagar", loyalty: 150, holdTime: "2:00", priority: "MEDIUM" },
    { name: "Neha Gupta", phone: "+91 65432 10987", city: "Koramangala", loyalty: 320, holdTime: "1:35", priority: "MEDIUM" },
    { name: "Vikram Singh", phone: "+91 54321 09876", city: "Whitefield", loyalty: 85, holdTime: "1:00", priority: "LOW" },
    { name: "Anjali Desai", phone: "+91 43210 98765", city: "HSR Layout", loyalty: 200, holdTime: "0:45", priority: "LOW" },
  ];

  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 40, marginTop: "18vh", color: "#fff" }} spin />} spinning={false}>
      {syncLoad ? (
        <SyncLoadingScreen
          colorVariable={colorVariable}
          formattedDateTime={formattedDateTime}
          clock1={clock1}
          percent={percent}
          productCategoryPercentage={productCategoryPercentage}
          productPercentage={productPercentage}
          promotionPercentage={promotionPercentage}
        />
      ) : (
        <div style={data.posScreenStyles.main}>
          <div style={{ display: "flex" }}>
            <FBLeftSidebar
              keyValue={keyValue}
              setKeyValue={setKeyValue}
              showMoreMenu={showMoreMenu}
              setShowMoreMenu={setShowMoreMenu}
              showOrderCompleteFlag={showOrderCompleteFlag}
              sortedSaleTypes={sortedSaleTypes}
              selectedSaleTypeIndex={selectedSaleTypeIndex}
              setSelectedSaleTypeIndex={setSelectedSaleTypeIndex}
              defaultFulfilmentType={defaultFulfilmentType}
              fulfilmentIconMap={fulfilmentIconMap}
              multilingual={multilingual}
              posConfig={posConfig}
              tillaccess={tillaccess}
              cart={cart}
              setCart={setCart}
              showSendToKitchen={showSendToKitchen}
              hasUnfiredItems={hasUnfiredItems}
              splitBillScreen={splitBillScreen}
              clearCartData={clearCartData}
              showProducts={showProducts}
              setShowProducts={setShowProducts}
              handleSelectedSaleTypeForProducts={handleSelectedSaleTypeForProducts}
              tillData={tillData}
              setSaleType={setSaleType}
              handleKeyvalue={handleKeyvalue}
              setPaymentVisible={setPaymentVisible}
              setSaleTypeProducts={setSaleTypeProducts}
              setReservationsBlank={setReservationsBlank}
              loadReservations={loadReservations}
              loadWaitlistForUI={loadWaitlistForUI}
              setWaitlistList={setWaitlistList}
              loading={loading}
              setLoading={setLoading}
              setShowOrderCompleteFlag={setShowOrderCompleteFlag}
              setSearchhistoryInput={setSearchhistoryInput}
              setOrderHistoryDetails={setOrderHistoryDetails}
              setFiltersFlag={setFiltersFlag}
              searchOrderHistory={searchOrderHistory}
              setSyncLoad={setSyncLoad}
              setReloadTablesFlag={setReloadTablesFlag}
              isUnlinkTillClicked={isUnlinkTillClicked}
              handleUnlinkTillClick={handleUnlinkTillClick}
              CWHardwareController={CWHardwareController}
              salesReportCWHCPrinter={salesReportCWHCPrinter}
              salesReportPrinter={salesReportPrinter}
              setIsCallCenterFlow={setIsCallCenterFlow}
              setShowCallCenterPage={setShowCallCenterPage}
              tableCards={tableCards}
              matchedRep={matchedRep}
              domainURL={domainURL}
              history={history}
            />

            <div data-zone="tables" data-zone-label="Tables" tabIndex={-1} style={{ width: "100%" }}>
              {keyValue === "0" ? (
                posConfig?.enableDineIn === "Y" ? (
                  <TableManagement
                    {...tableLayoutProps}
                    loading={loading}
                    setLoading={setLoading}
                    categorieFlag={categorieFlag}
                    setCategorieFlag={setCategorieFlag}
                    addDefinedProductWithAddons={addDefinedProductWithAddons}
                    restaurantProductCategory={restaurantProductCategory}
                    productsData={productsData}
                    pickProduct={pickProduct}
                    increaseProductQty={increaseProductQty}
                    decreaseProductQty={decreaseProductQty}
                    deleteProduct={deleteProduct}
                    setDisplayCustomerSearch={setDisplayCustomerSearch}
                    handleVoid={handleVoid}
                    paymentVisible={paymentVisible}
                    setPaymentVisible={setPaymentVisible}
                    cart={cart}
                    setCart={setCart}
                    deleteCart={deleteCart}
                    setKeyValue={setKeyValue}
                    handleOrder={handleOrder}
                    showProducts={showProducts}
                    setShowProducts={setShowProducts}
                    tableCards={tableCards}
                    setTableCards={setTableCards}
                    occupiedDataTablesData={occupiedDataTablesData}
                    setOcupiedTablesData={setOcupiedTablesData}
                    reservedTablesData={reservedTablesData}
                    setReservedTablesData={setReservedTablesData}
                    setProductsData={setProductsData}
                    saleTypeProducts={saleTypeProducts}
                    setSaleTypeProducts={setSaleTypeProducts}
                    requestPayment={requestPayment}
                    showOrderCompleteFlag={showOrderCompleteFlag}
                    setShowOrderCompleteFlag={setShowOrderCompleteFlag}
                    handleCashPayment={handleCashPayment}
                    mainTableData={mainTableData}
                    setMainTableData={setMainTableData}
                    fireItems={fireItems}
                    setFireItems={setFireItems}
                    fireMode={fireMode}
                    setFireMode={setFireMode}
                    pendingFireItems={pendingFireItems}
                    setPendingFireItems={setPendingFireItems}
                    handleCopyKOT={handleCopyKOT}
                    waitlistTab={waitlistTab}
                    setWaitlistTab={setWaitlistTab}
                    saveToWaitlist={saveToWaitlist}
                    waitlistSubmitting={waitlistSubmitting}
                    waitlistForm={waitlistForm}
                    setWaitlistForm={setWaitlistForm}
                    validateWaitlistForm={validateWaitlistForm}
                    setWaitlistList={setWaitlistList}
                    waitlistList={waitlistList}
                    setWaitlistErrors={setWaitlistErrors}
                    waitlistErrors={waitlistErrors}
                    reservationList={reservationList}
                    setReservationList={setReservationList}
                    errors={errors}
                    setErrors={setErrors}
                    form={form}
                    setForm={setForm}
                    reserveModalOpen={reserveModalOpen}
                    setReserveModalOpen={setReserveModalOpen}
                    drawerOpen={drawerOpen}
                    setDrawerOpen={setDrawerOpen}
                    loadReservations={loadReservations}
                    waitlistDrawerOpen={waitlistDrawerOpen}
                    setWaitlistDrawerOpen={setWaitlistDrawerOpen}
                    loadWaitlistForUI={loadWaitlistForUI}
                    guestForm={guestForm}
                    setKioskUI={setKioskUI}
                    kioskLogin={kioskLogin}
                    isNewGuestCustomer={isNewGuestCustomer}
                    setIsNewGuestCustomer={setIsNewGuestCustomer}
                    reservationsBlank={reservationsBlank}
                    setReservationsBlank={setReservationsBlank}
                    mergeDrawerOpen={mergeDrawerOpen}
                    setMergeDrawerOpen={setMergeDrawerOpen}
                    handleTable={handleTable}
                    inputRef={inputRef}
                    displayReserveTablesPopup={displayReserveTablesPopup}
                    setDisplayReserveTablesPopup={setDisplayReserveTablesPopup}
                    handleReserveTable={handleReserveTable}
                    radioValue={radioValue}
                    setRadioValue={setRadioValue}
                    reserveTableForm={reserveTableForm}
                    handleNumberClick={handleNumberClick}
                    handleClick={handleClick}
                    setInputFields={setInputFields}
                    inputFields={inputFields}
                    numbers={numbers}
                    noOfPersons={noOfPersons}
                    setNumberOfPersons={setNumberOfPersons}
                    tableList={tableList}
                    setTableList={setTableList}
                    selectData={selectData}
                    setSelectData={setSelectData}
                    handleOnChange={handleOnChange}
                    guestMobile={guestMobile}
                    setGuestMobile={setGuestMobile}
                    reservePhone={reservePhone}
                    setReservePhone={setReservePhone}
                    addNewCustomer={addNewCustomer}
                    handleKeyvalue={handleKeyvalue}
                    setOederedData={setOederedData}
                    handleDisplayOk={handleDisplayOk}
                    productsList={productsList}
                    selectedProductId={selectedProductId}
                    setSelectedProductId={setSelectedProductId}
                    setsaleTypeProducts={setSaleTypeProducts}
                    addonSourceItem={addonSourceItem}
                    setAddonSourceItem={setAddonSourceItem}
                    showAddonsCustomizePopup={showAddonsCustomizePopup}
                    setShowAddonsCustomizePopUp={setShowAddonsCustomizePopUp}
                    addonRepeatDisabled={addonRepeatDisabled}
                    setAddonRepeatDisabled={setAddonRepeatDisabled}
                    setDisplayAddOnSelection={setDisplayAddOnSelection}
                    displayAddOnSelection={displayAddOnSelection}
                    selectedProduct={selectedProduct}
                    setSelectedProduct={setSelectedProduct}
                    setAddOnsList={setAddOnsList}
                    addOnsList={addOnsList}
                    handleAddOnModal={handleAddOnModal}
                    productSearchInput={productSearchInput}
                    setProductSearchInput={setProductSearchInput}
                    reloadTablesFlag={reloadTablesFlag}
                  />
                ) : posConfig?.enableTakeAway === "Y" ? (
                  <MenuLayout
                    {...tableLayoutProps}
                    categorieFlag={categorieFlag}
                    setCategorieFlag={setCategorieFlag}
                    setProductsData={setProductsData}
                    showSendToKitchen={showSendToKitchen}
                    setShowSendToKitchen={setShowSendToKitchen}
                    selectedProductForNotes={selectedProductForNotes}
                    notesValue={notesValue}
                    setNotesValue={setNotesValue}
                    setIsInputFocused={setIsInputFocused}
                    keyboardRef={keyboardRef}
                    setSelectedProductForNotes={setSelectedProductForNotes}
                    copyKOTVisible={copyKOTVisible}
                    setCopyKOTVisible={setCopyKOTVisible}
                    groupedFiredItems={groupedFiredItems}
                    setGroupedFiredItems={setGroupedFiredItems}
                    openCopyKOTModal={openCopyKOTModal}
                    selectedCopyItems={selectedCopyItems}
                    setSelectedCopyItems={setSelectedCopyItems}
                    setFireMode={setFireMode}
                    handleOrder={handleOrder}
                    setFireItems={setFireItems}
                    setOederedData={setOederedData}
                    handleDisplayOk={handleDisplayOk}
                    pendingFireItems={pendingFireItems}
                    setPendingFireItems={setPendingFireItems}
                    productsList={productsList}
                    setTableCards={setTableCards}
                    setTableList={setTableList}
                    openDisplayParkedBillModal={openDisplayParkedBillModal}
                    filterdParkedList={filterdParkedList}
                    setFilterdParkedList={setFilterdParkedList}
                    retrieveParkedData={retrieveParkedData}
                    discardMessage={discardMessage}
                    parkedList={parkedList}
                    setParkedList={setParkedList}
                    displayAddOnSelection={displayAddOnSelection}
                    setDisplayAddOnSelection={setDisplayAddOnSelection}
                    setSelectedSaleTypeIndex={setSelectedSaleTypeIndex}
                    addonSourceItem={addonSourceItem}
                    setAddonSourceItem={setAddonSourceItem}
                    showAddonsCustomizePopup={showAddonsCustomizePopup}
                    setShowAddonsCustomizePopUp={setShowAddonsCustomizePopUp}
                    addonRepeatDisabled={addonRepeatDisabled}
                    setAddonRepeatDisabled={setAddonRepeatDisabled}
                    saleTypeProducts={saleTypeProducts}
                    setsaleTypeProducts={setSaleTypeProducts}
                    selectedProduct={selectedProduct}
                    setSelectedProduct={setSelectedProduct}
                    setAddOnsList={setAddOnsList}
                    addOnsList={addOnsList}
                    handleAddOnModal={handleAddOnModal}
                    productSearchInput={productSearchInput}
                    setProductSearchInput={setProductSearchInput}
                    loading={loading}
                    setLoading={setLoading}
                  />
                ) : (
                  <HomeDeliveryComponent
                    {...tableLayoutProps}
                    categorieFlag={categorieFlag}
                    setCategorieFlag={setCategorieFlag}
                    addDefinedProductWithAddons={addDefinedProductWithAddons}
                    restaurantProductCategory={restaurantProductCategory}
                    productsData={productsData}
                    pickProduct={pickProduct}
                    increaseProductQty={increaseProductQty}
                    decreaseProductQty={decreaseProductQty}
                    deleteProduct={deleteProduct}
                    setDisplayCustomerSearch={setDisplayCustomerSearch}
                    handleVoid={handleVoid}
                    setPaymentVisible={setPaymentVisible}
                    showProducts={showProducts}
                    setShowProducts={setShowProducts}
                    isSaleTypeFlag={isSaleTypeFlag}
                    setIsSaleTypeFlag={setIsSaleTypeFlag}
                    setProductsData={setProductsData}
                  />
                )
              ) : keyValue === "3" ? (
                <OrderListComponent
                  {...tableLayoutProps}
                  setSearchhistoryInput={setSearchhistoryInput}
                  sortedSaleTypes={sortedSaleTypes}
                  setSelectedSaleTypeIndex={setSelectedSaleTypeIndex}
                  addSelectedReturnProductsToCart={addSelectedReturnProductsToCart}
                  selectedReturnOrder={selectedReturnOrder}
                  setSelectedReturnOrder={setSelectedReturnOrder}
                  checkedKeys={checkedKeys}
                  setCheckedKeys={setCheckedKeys}
                  getProductData={getProductData}
                  handleSaveReturnCartRecord={handleSaveReturnCartRecord}
                  dataSource={dataSource}
                  setDataSource={setDataSource}
                  saleTypeProducts={saleTypeProducts}
                  setsaleTypeProducts={setSaleTypeProducts}
                  showReturnPurchase={showReturnPurchase}
                  setShowReturnPurchase={setShowReturnPurchase}
                  selectPurchaseBillForReturn={selectPurchaseBillForReturn}
                  retrunSearchType={retrunSearchType}
                  setReturnSearchType={setReturnSearchType}
                  searchReturnHistory={searchReturnHistory}
                  setMainTableData={setMainTableData}
                  mainTableData={mainTableData}
                />
              ) : keyValue === "5" ? (
                <CashManagement {...tableLayoutProps} />
              ) : keyValue === "8" ? (
                <CustomersComponent {...tableLayoutProps} />
              ) : keyValue === "2" ? (
                <MenuLayout
                  {...tableLayoutProps}
                  categorieFlag={categorieFlag}
                  setCategorieFlag={setCategorieFlag}
                  addDefinedProductWithAddons={addDefinedProductWithAddons}
                  cart={cart}
                  setCart={setCart}
                  setProductsData={setProductsData}
                  showSendToKitchen={showSendToKitchen}
                  setShowSendToKitchen={setShowSendToKitchen}
                  selectedProductForNotes={selectedProductForNotes}
                  notesValue={notesValue}
                  setNotesValue={setNotesValue}
                  setIsInputFocused={setIsInputFocused}
                  keyboardRef={keyboardRef}
                  setSelectedProductForNotes={setSelectedProductForNotes}
                  copyKOTVisible={copyKOTVisible}
                  setCopyKOTVisible={setCopyKOTVisible}
                  groupedFiredItems={groupedFiredItems}
                  setGroupedFiredItems={setGroupedFiredItems}
                  openCopyKOTModal={openCopyKOTModal}
                  selectedCopyItems={selectedCopyItems}
                  setSelectedCopyItems={setSelectedCopyItems}
                  handleOrder={handleOrder}
                  setFireItems={setFireItems}
                  setFireMode={setFireMode}
                  setOederedData={setOederedData}
                  handleDisplayOk={handleDisplayOk}
                  pendingFireItems={pendingFireItems}
                  setPendingFireItems={setPendingFireItems}
                  productsList={productsList}
                  setTableCards={setTableCards}
                  setTableList={setTableList}
                  openDisplayParkedBillModal={openDisplayParkedBillModal}
                  filterdParkedList={filterdParkedList}
                  setFilterdParkedList={setFilterdParkedList}
                  retrieveParkedData={retrieveParkedData}
                  discardMessage={discardMessage}
                  parkedList={parkedList}
                  setParkedList={setParkedList}
                  displayAddOnSelection={displayAddOnSelection}
                  setDisplayAddOnSelection={setDisplayAddOnSelection}
                  setSelectedSaleTypeIndex={setSelectedSaleTypeIndex}
                  addonSourceItem={addonSourceItem}
                  setAddonSourceItem={setAddonSourceItem}
                  showAddonsCustomizePopup={showAddonsCustomizePopup}
                  setShowAddonsCustomizePopUp={setShowAddonsCustomizePopUp}
                  addonRepeatDisabled={addonRepeatDisabled}
                  setAddonRepeatDisabled={setAddonRepeatDisabled}
                  saleTypeProducts={saleTypeProducts}
                  setsaleTypeProducts={setSaleTypeProducts}
                  selectedProduct={selectedProduct}
                  setSelectedProduct={setSelectedProduct}
                  setAddOnsList={setAddOnsList}
                  addOnsList={addOnsList}
                  handleAddOnModal={handleAddOnModal}
                  productSearchInput={productSearchInput}
                  setProductSearchInput={setProductSearchInput}
                  loading={loading}
                  setLoading={setLoading}
                />
              ) : keyValue === "1" ? (
                <HomeDeliveryComponent
                  {...tableLayoutProps}
                  categorieFlag={categorieFlag}
                  setCategorieFlag={setCategorieFlag}
                  addDefinedProductWithAddons={addDefinedProductWithAddons}
                  restaurantProductCategory={restaurantProductCategory}
                  productsData={productsData}
                  pickProduct={pickProduct}
                  increaseProductQty={increaseProductQty}
                  decreaseProductQty={decreaseProductQty}
                  deleteProduct={deleteProduct}
                  setDisplayCustomerSearch={setDisplayCustomerSearch}
                  handleVoid={handleVoid}
                  setPaymentVisible={setPaymentVisible}
                  showProducts={showProducts}
                  setShowProducts={setShowProducts}
                  isSaleTypeFlag={isSaleTypeFlag}
                  setIsSaleTypeFlag={setIsSaleTypeFlag}
                  setProductsData={setProductsData}
                  setOederedData={setOederedData}
                  handleDisplayOk={handleDisplayOk}
                  pendingFireItems={pendingFireItems}
                  setPendingFireItems={setPendingFireItems}
                />
              ) : keyValue === "4" ? (
                <TableFeatures
                  reserveModalOpen={reserveModalOpen}
                  drawerOpen={drawerOpen}
                  setDrawerOpen={setDrawerOpen}
                  mergeDrawerOpen={mergeDrawerOpen}
                  closeMergeDrawer={() => setMergeDrawerOpen(false)}
                  waitlistDrawerOpen={waitlistDrawerOpen}
                  setWaitlistDrawerOpen={setWaitlistDrawerOpen}
                  loadWaitlistForUI={loadWaitlistForUI}
                  waitlistTab={waitlistTab}
                  setWaitlistTab={setWaitlistTab}
                  saveToWaitlist={saveToWaitlist}
                  waitlistSubmitting={waitlistSubmitting}
                  validateWaitlistForm={validateWaitlistForm}
                  waitlistForm={waitlistForm}
                  setWaitlistForm={setWaitlistForm}
                  waitlistErrors={waitlistErrors}
                  setWaitlistErrors={setWaitlistErrors}
                  waitlistList={waitlistList}
                  setWaitlistList={setWaitlistList}
                  getWaitlist={getWaitlist}
                  reservationList={reservationList}
                  setReservationList={setReservationList}
                  errors={errors}
                  setErrors={setErrors}
                  form={form}
                  setForm={setForm}
                  selectData={selectData}
                  setSelectData={setSelectData}
                  tableList={tableList}
                  setTableList={setTableList}
                  setReserveModalOpen={setReserveModalOpen}
                  setTableCards={setTableCards}
                  setOcupiedTablesData={setOcupiedTablesData}
                  setReservedTablesData={setReservedTablesData}
                  setMainTableData={setMainTableData}
                  handleTable={handleTable}
                  loadReservations={loadReservations}
                  reservationsBlank={reservationsBlank}
                  setReservationsBlank={setReservationsBlank}
                  displayReserveTablesPopup={displayReserveTablesPopup}
                  setDisplayReserveTablesPopup={setDisplayReserveTablesPopup}
                  handleReserveTable={handleReserveTable}
                  radioValue={radioValue}
                  setRadioValue={setRadioValue}
                  guestForm={guestForm}
                  handleNumberClick={handleNumberClick}
                  reserveTableForm={reserveTableForm}
                  handleClick={handleClick}
                  inputFields={inputFields}
                  setInputFields={setInputFields}
                  numbers={numbers}
                  setNumberOfPersons={setNumberOfPersons}
                  noOfPersons={noOfPersons}
                  handleOnChange={handleOnChange}
                  setReservePhone={setReservePhone}
                  reservePhone={reservePhone}
                  addNewCustomer={addNewCustomer}
                  setCart={setCart}
                  cart={cart}
                  tableCards={tableCards}
                  selectedTable={selectedTable}
                  keyValue={keyValue}
                  setShowProducts={setShowProducts}
                  transferBill={transferBill}
                  setTransferBill={setTransferBill}
                  seatGuestDrawerOpen={seatGuestDrawerOpen}
                  setSeatGuestDrawerOpen={setSeatGuestDrawerOpen}
                  clearCartData={clearCartData}
                />
              ) : null}
            </div>
          </div>
        </div>
      )}
      <RestaurantModals
        selectedTable={selectedTable}
        orderFlags={orderFlags}
        setOrderFlags={setOrderFlags}
        getCustomerData={getCustomerData}
        tableList={tableList}
        setTableList={setTableList}
        displayAddOnSelection={displayAddOnSelection}
        handleAddOnModalClose={handleAddOnModalClose}
        addOnsList={addOnsList}
        selectedProduct={selectedProduct}
        selectedAddons={selectedAddons}
        handleAddOnValue={handleAddOnValue}
        currencyType={currencyType}
        selectedRowKeys={selectedRowKeys}
        selectedProductInCart={selectedProductInCart}
        decreaseProductQty={decreaseProductQty}
        handleQty={handleQty}
        increaseProductQty={increaseProductQty}
        handleAdd={handleAdd}
        selectedItemsModalOpen={selectedItemsModalOpen}
        setSelectedItemsModalOpen={setSelectedItemsModalOpen}
        selectProductInCart={selectProductInCart}
        handleDisplayOk={handleDisplayOk}
        displayOrderItemsModal={displayOrderItemsModal}
        orderStatus={orderStatus}
        selectedOrderStatus={selectedOrderStatus}
        handleOrderStatusSelection={handleOrderStatusSelection}
        handleOrderStatus={handleOrderStatus}
        setDisplayOrderItemsModal={setDisplayOrderItemsModal}
        orderDetails={orderDetails}
        handleStatusButton={handleStatusButton}
        barcodeOrderStatusModal={barcodeOrderStatusModal}
        setBarcodeOrderStatusModal={setBarcodeOrderStatusModal}
        barcodeOrderList={barcodeOrderList}
        handleBarcodeOrderPrint={handleBarcodeOrderPrint}
        handleAccept={handleAccept}
        cart={cart}
        tillData={tillData}
        openPaymentModal={openPaymentModal}
        billConfirmationModalOpen={billConfirmationModalOpen}
        setBillConfirmationModalOpen={setBillConfirmationModalOpen}
        parkedList={parkedList}
        openDisplayParkedBillModal={openDisplayParkedBillModal}
        orderTypeSelection={orderTypeSelection}
        manualDiscountModalVisible={manualDiscountModalVisible}
        setManualDiscountInput={setManualDiscountInput}
        setManualDiscountModalVisible={setManualDiscountModalVisible}
        notesModalOpen={notesModalOpen}
        setNotesModalOpen={setNotesModalOpen}
        handleCancelOrder={handleCancelOrder}
        showSendToKitchen={showSendToKitchen}
        setShowSendToKitchen={setShowSendToKitchen}
        orderedData={orderedData}
        setOederedData={setOederedData}
        fireMode={fireMode}
        setFireMode={setFireMode}
        pendingFireItems={pendingFireItems}
        setPendingFireItems={setPendingFireItems}
        setCart={setCart}
      />
      <RetailModals {...props} />
    </Spin>
  );
};
export default FBLayout;
